var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-expansion-panel",
    [
      _c(
        "v-expansion-panel-header",
        { staticClass: "pl-3", on: { click: _vm.loadOwners } },
        [
          _c(
            "div",
            [
              _c("v-icon", [_vm._v("mdi-account-key-outline")]),
              _c("span", { staticClass: "ml-1" }, [_vm._v("Entra ID Owners")]),
            ],
            1
          ),
        ]
      ),
      _c(
        "v-expansion-panel-content",
        [
          _vm.errorMessage
            ? _c(
                "v-alert",
                { attrs: { type: "error", outlined: "", dense: "" } },
                [_vm._v(_vm._s(_vm.errorMessage))]
              )
            : _vm._e(),
          _vm.pendingMessage
            ? _c(
                "v-alert",
                { attrs: { type: "warning", outlined: "", dense: "" } },
                [_vm._v(_vm._s(_vm.pendingMessage))]
              )
            : _vm._e(),
          _vm.loading
            ? _c("v-progress-linear", {
                staticClass: "mb-3",
                attrs: { indeterminate: "", color: "#006c27" },
              })
            : _vm._e(),
          _vm.status
            ? [
                _c("div", { staticClass: "text-subtitle-2 text-left mb-2" }, [
                  _vm._v("Application registration owners"),
                ]),
                _c("v-simple-table", {
                  staticClass: "mb-4",
                  attrs: { dense: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function () {
                          return [
                            _c("thead", [
                              _c("tr", [
                                _c("th", [_vm._v("Name")]),
                                _c("th", [_vm._v("Type")]),
                                _c("th", [_vm._v("Object ID")]),
                              ]),
                            ]),
                            _c(
                              "tbody",
                              _vm._l(
                                _vm.status.applicationRegistrationOwners,
                                function (owner) {
                                  return _c(
                                    "tr",
                                    { key: "app-" + owner.objectId },
                                    [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(owner.displayName || "-")
                                        ),
                                      ]),
                                      _c("td", [
                                        _vm._v(_vm._s(owner.objectType)),
                                      ]),
                                      _c(
                                        "td",
                                        { staticClass: "text-caption" },
                                        [_vm._v(_vm._s(owner.objectId))]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1945385473
                  ),
                }),
                _c("div", { staticClass: "text-subtitle-2 text-left mb-2" }, [
                  _vm._v("Service principal owners"),
                ]),
                _c("v-simple-table", {
                  staticClass: "mb-4",
                  attrs: { dense: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function () {
                          return [
                            _c("thead", [
                              _c("tr", [
                                _c("th", [_vm._v("Name")]),
                                _c("th", [_vm._v("Type")]),
                                _c("th", [_vm._v("Object ID")]),
                              ]),
                            ]),
                            _c(
                              "tbody",
                              _vm._l(
                                _vm.status.servicePrincipalOwners,
                                function (owner) {
                                  return _c(
                                    "tr",
                                    { key: "sp-" + owner.objectId },
                                    [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(owner.displayName || "-")
                                        ),
                                      ]),
                                      _c("td", [
                                        _vm._v(_vm._s(owner.objectType)),
                                      ]),
                                      _c(
                                        "td",
                                        { staticClass: "text-caption" },
                                        [_vm._v(_vm._s(owner.objectId))]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3463355559
                  ),
                }),
                _vm.status.state === "INCONSISTENT"
                  ? _c(
                      "v-alert",
                      { attrs: { type: "warning", outlined: "", dense: "" } },
                      [
                        _vm._v(
                          " Your ownership differs between the application registration and service principal. The action is disabled until Entra ID is consistent. "
                        ),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "white--text",
                        attrs: {
                          disabled:
                            _vm.loading ||
                            _vm.updating ||
                            _vm.pendingMessage ||
                            _vm.status.state === "INCONSISTENT",
                          color: "#006c27",
                        },
                        on: { click: _vm.toggleOwnership },
                      },
                      [
                        _vm.updating
                          ? _c("v-progress-circular", {
                              staticClass: "mr-2",
                              attrs: {
                                indeterminate: "",
                                size: "18",
                                width: "2",
                              },
                            })
                          : _vm._e(),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.status.state === "OWNED"
                                ? "Remove myself as Entra owner"
                                : "Add myself as Entra owner"
                            ) +
                            " "
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }